import * as React from 'react';

import { translate } from '~l10n/client';
import cx from 'classnames';

import { SmallButton } from '~shared/components/buttons';
import { useCreateWorkspaceQuizLock } from '~teacher/hook/workspaces/useCreateWorkspaceQuizLock';
import { useWorkspaceQuizLock } from '~teacher/hook/workspaces/useWorkspaceQuizLock';

import { LockStatus } from '../../../../../api/workspaces/lock';
import { assertUnreachable } from '../../../../../util/assertUnreachable';

interface Props {
  canEditQuiz: boolean;
  onHandleSaveAndExit: () => Promise<void>;
  isUploadingImages: boolean;
  isControlsDisabled: boolean;
  workspaceQuizId: string;
  workspaceId: string;
}

export function EditOrSaveButton({
  onHandleSaveAndExit,
  workspaceId,
  workspaceQuizId,
  isControlsDisabled,
  isUploadingImages,
  canEditQuiz,
}: Props) {
  const quizLockQuery = useWorkspaceQuizLock({ workspaceQuizId, workspaceId });
  const createQuizLockMutation = useCreateWorkspaceQuizLock();
  const buttonClass = cx('whitespace-no-wrap ml-4');
  if (quizLockQuery.isSuccess) {
    const { lockStatus } = quizLockQuery.data;

    switch (lockStatus) {
      case LockStatus.LockedBySomeone: {
        return (
          <SmallButton
            className={buttonClass}
            onClick={() => {
              /* empty */
            }}
            isDisabled={true}
          >
            {translate('Edit Quiz')}
          </SmallButton>
        );
      }
      case LockStatus.LockedByYou: {
        return (
          <SmallButton
            className={buttonClass}
            onClick={() => onHandleSaveAndExit()}
            isDisabled={isControlsDisabled || isUploadingImages}
          >
            {translate('Save and Exit')}
          </SmallButton>
        );
      }
      case LockStatus.Unlocked: {
        return (
          <SmallButton
            isDisabled={!canEditQuiz}
            className={buttonClass}
            onClick={() => {
              createQuizLockMutation.mutate({ workspaceQuizId, workspaceId });
            }}
          >
            {translate('Edit Quiz')}
          </SmallButton>
        );
      }
      default:
        assertUnreachable(lockStatus);
    }
  } else if (quizLockQuery.isError) {
    // Currently if a viewer queries a lock they always get a 403
    return (
      <SmallButton
        className={buttonClass}
        onClick={() => {
          /* empty */
        }}
        isDisabled={true}
      >
        {translate('Edit Quiz')}
      </SmallButton>
    );
  }

  return (
    <SmallButton className={buttonClass} isDisabled={true}>
      {translate('loading')}
    </SmallButton>
  );
}
